module.exports = __webpack_public_path__ + "static/img/s5.481a932.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/s5.png
// module id = gmmf
// module chunks = 0